import PropTypes from 'prop-types';
import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';

const EmbeddedDecipherQuestion = props => {
  const { id, required } = props;
  const domain = window.location.hostname.includes('icanmakeitbetter') ? 'icanmakeitbetter.com' : 'icmib.com'
  const list = props.build_preview ? 'icmib_test' : 'icmib'

  function redirect_url(environment) {
    const token = props.build_preview ? {id: 'xxx'} : props.token
    if (environment === 'development') {
      return `http://aperture.lvh.me:3000/decipher/embedded_responses/capture?token_id=${token.id}&project_code=${props.decipher_project_code}`;
    } else if (environment === 'staging') {
      return `https://staging.icmibs.com/decipher/embedded_responses/capture?token_id=${token.id}&project_code=${props.decipher_project_code}`;
    }
    else {
      return `https://${props.subdomain}.${domain}/decipher/embedded_responses/capture?token_id=${token.id}&project_code=${props.decipher_project_code}`;
    }
  }
  const srcUrl = `https://isa.decipherinc.com/survey/selfserve/68c/${props.decipher_project_code}/?list=${list}&user_redirect=${encodeURIComponent(redirect_url(props.environment))}&community_color=${props.color?.replace(/#/,'')}`;
  return (
    <QuestionWrapper {...props}>
      { props.build_preview ?
          <div className="lh-29">
            <strong>This is a decipher embedded question in build preview with Decipher Project Code: {props.decipher_project_code}</strong>
            <div>Debugging: The redirect is:</div>
            <div>{encodeURIComponent(redirect_url(props.environment))}</div>
          </div>
        :
          <p style={{"maxWidth" : "100%"}} className="lh-29">
            <iframe
              id='embeddedIframe'
              style={{"width": "100%", "height": "100%", "border": "0"}}
              onLoad= {function () { $(window).scrollTop(0) }}
              overflow='scroll'
              allow='camera;microphone'
              src={srcUrl} >
            </iframe>
          </p>
      }
    </QuestionWrapper>
  );
};

export default EmbeddedDecipherQuestion;
